import React, { useContext, memo } from 'react';
import { AppContext } from 'src/components/app-context';
import { AdContext } from '../context';
import { getAdService } from '.';
import { getAdContextCookie } from '../helpers/cookie';

const AdServiceContext = React.createContext<any>(null);
AdServiceContext.displayName = 'AdServiceContext';

interface AdServiceContextProviderProps {
  children: JSX.Element | React.ReactElement;
}
const AdServiceContextProvider = (props: AdServiceContextProviderProps) => {
  const { market } = useContext(AppContext);
  const adContext = useContext(AdContext);
  const serviceName = getAdContextCookie().service || market.ads.service;
  const service = getAdService(serviceName);
  const config = market.ads[serviceName] || {};

  return adContext.active ? (
    <service.provider
      config={config}
      adContext={adContext}
      baseProvider={AdServiceContext.Provider}
    >
      {props.children}
    </service.provider>
  ) : (
    props.children
  );
};

export const useAdServiceContext = () => useContext(AdServiceContext);

export default {
  Provider: memo(AdServiceContextProvider),
  Consumer: AdServiceContext.Consumer,
};
